import '../styles/ModalCambios.css';

export default function ModalCambios({ onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-cambios">
        <h3>¡¡Novedades de la versión!!</h3>

        <ul className="lista-cambios">
          <li>CONSENTIMIENTOS:
            <ul>
              <li className="lista-cambios 2">Nuevo campo observaciones en la firma, se rellena antes de mandar para firmar</li>
              <li className="lista-cambios 2">Firma sale correctamente tanto de paciente como de profesional</li>
            </ul>
          </li>          
          <li>CALENDARIO:
            <ul>
              <li className="lista-cambios 2">Nuevo punto de menú "Calendario". Con recordatios diarios y sincronización hacia google calendar.</li>
              <li className="lista-cambios 2">SOLO introducir y elminar citas nuevas desde aplicación (consultar en google calendar se puede)</li>
              <li className="lista-cambios 2">Citas ya creadas desde google calendar como hasta ahora</li>
              <li className="lista-cambios 2">Si se crea cita desde aplicación, no borrar en google calendar. Borrar desde aplicación</li>
            </ul>
          </li>
          <li>IMAGENES:
            <ul>
              <li className="lista-cambios 2">Error imagenes antiguas no aparecían en pacientes solucionado</li>
              <li className="lista-cambios 2">Ya se pueden subir imagenes de hasta 10mb</li>
            </ul>
          </li> 
        </ul>

        <h4>Recordatorios</h4>
        <ul className="lista-recordatorios">
          <li>Ya funciona el odontograma, solamente al entrar un nuevo tratamiento, comprobar que no existe otro llamdo igual</li>
          <li>Cualquier duda o error, contactar con Raúl.</li>
        </ul>

        <div className="modal-acciones">
          <button onClick={onClose}>Entendido</button>
        </div>
      </div>
    </div>
  );
}
